import React, { useEffect, useState } from "react";
import { Phone, PawPrint } from "lucide-react";
import { Button } from "./ui/button";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-xl border-b border-slate-100 shadow-[0_2px_20px_rgb(0,0,0,0.04)]"
          : "bg-white/70 backdrop-blur-md"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 md:h-24">
          <a
            href="#hero"
            data-testid="site-logo"
            aria-label="NoriVet — Clínica Veterinaria"
            className="flex items-center group"
          >
            <img
              src="/norivet-logo.png"
              alt="NoriVet — Clínica Veterinaria"
              className="h-16 md:h-20 w-auto group-hover:scale-105 transition-transform"
            />
          </a>

          <a href="tel:684366280" data-testid="header-call-button">
            <Button
              size="lg"
              className="rounded-full bg-violet-600 hover:bg-violet-700 text-white shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all px-4 md:px-6 h-10 md:h-11"
            >
              <Phone className="w-4 h-4 md:mr-2" strokeWidth={2.4} />
              <span className="hidden md:inline font-medium">
                684 36 62 80
              </span>
              <span className="md:hidden ml-2 font-medium">Llamar</span>
            </Button>
          </a>
        </div>
      </div>
    </header>
  );
};
